import React, { useState } from "react";
import Pagination from "./table/Pagination";
import { IconButton, makeStyles } from "@material-ui/core";
import { AddCircleOutline } from "@material-ui/icons";
import AddUserForm from "./modal/AddUserForm";
const useStyle = makeStyles((theme) => ({
  userNumber: {
    display: "flex",
    alignItems: "center",
  },
  languageButton: {
    marginTop: "10px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
  root: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 10px",
  },
  button: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    paddingRight: "16px",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.12)",
    cursor: "pointer",
    backgroundColor: theme.palette.primary.main,
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  icon: {
    fontSize: "18px",
  },
}));
const HeaderController = () => {
  const classes = useStyle();
  const [isShowDialog, setIsShowDialog] = useState(false);
  return (
    <div className={classes.root}>
      <button className={classes.button} onClick={() => setIsShowDialog(true)}>
        <IconButton>
          <AddCircleOutline className={classes.icon} />
        </IconButton>
        新規
      </button>

      {isShowDialog && <AddUserForm setIsShow={setIsShowDialog} />}
    </div>
  );
};

export default HeaderController;
